import { render } from "./DividendsIssuer.vue?vue&type=template&id=fd8a0ee8&scoped=true"
import script from "./DividendsIssuer.vue?vue&type=script&lang=js"
export * from "./DividendsIssuer.vue?vue&type=script&lang=js"

import "./DividendsIssuer.vue?vue&type=style&index=0&id=fd8a0ee8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd8a0ee8"]])

export default __exports__